module.exports = __webpack_public_path__ + "static/media/seedling.b71d08a0.svg";